import Box from "@mui/material/Box";
import useRequestedDocumentRepository from "../../../../../../repository/emergency/useRequestedDocumentRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import File from "../../../../../../material/file/File";

export default function ({requestedDocumentId}) {
    const requestedDocumentRepository = useRequestedDocumentRepository();
    /** @type RequestedDocument */
    const requestedDocument = requestedDocumentRepository.findOneById(requestedDocumentId).select();
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (isNull(requestedDocument)) return;

        fetch();
    }, []);

    const fetch = async () => {
        setFile(await requestedDocumentRepository.getFile(requestedDocument.getId()));
    }

    if (isNull(requestedDocument)) return null;

    return (
        <Box mt={3}>
            {
                !isNull(file)
                    ? (
                        <File base64={file.base64} contentType={file.content_type} filename={requestedDocument.getName()}/>
                    )
                    : null
            }
        </Box>
    )
}